export const getItemToFocus = (entry, carousel, itemIndex) =>
  entry.isIntersecting && carousel.children[itemIndex].querySelector("a");
